import { UPDATE_STATES } from "Redux/Actions/statesActions";

const INITIAL_STATE = {
  statesData: [],
};

const statesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_STATES: {
      return {
        ...state,
        ...action.value,
      };
    }
    default:
      return state;
  }
};

export default statesReducer;
